export class TextFieldHarnessController {
  public emailValue: string;
  public textValue: string;
  public numberValue: number;
  public readOnly = "Unavailable option";
  public textChanges: any = {};
  public textChangesString = "";

  public changed(text: string) {
    if (!this.textChanges[text]) {
      this.textChanges[text] = 0;
    }
    this.textChanges[text]++;
    this.textChangesString = Object.keys(this.textChanges)
      .map((key) => `"${key}": ${this.textChanges[key]}`)
      .join("\n");
  }
}
